export type formType = {
  aggravatingFactor: number | null;
  averageTemp: number | null;
  bachNumber: number | null;
  bachVolume: number | null;
  civilEngDegrad: number | null;
  civilEngDegradComment: null | string;
  factorComment: null | string;
  treatmentType: null | string;
  crack: boolean | null;
  concreteAlteration: boolean | null;
  dco: number | any;
  id: number | any;
  itv: boolean | null;
  compressor: boolean | null;
  flowMesure: boolean | null;
  itvComment: null | string;
  itvDate: string | any;
  lastVisitDate: string | any;
  lastMeasurementDate: string | any;
  mainInstallCode: string | null;
  qualiMeasure: null | number;
  qualiMeasureComment: string | null;
  siteVisit: boolean | null;
  treatmentDevice: boolean | null;
  siteVisitComment: null | any;
  smellDevice: boolean | null;
  smellObservation: boolean | null;
  smellSensitivity: boolean | null;
  colPoolSmellSensitivity: boolean | null;
  tamponCorrosion: boolean | null;
};
export type formScoringGridType = {
  id: number | null;
  mainInstallCode: string | null;
  posteResidenceTime1: number | null;
  posteResidenceTime2: number | null;
  posteResidenceTime3: number | null;
  residenceTime1: number | null;
  residenceTime2: number | null;
  residenceTime3: number | null;
  selfCleansing1: number | null;
  selfCleansing2: number | null;
  selfCleansing3: number | null;
  boonLister1: number | null;
  boonLister2: number | null;
  boonLister3: number | null;
};

export type Validation = {
  aggravatingFactor: null | number;
  averageTemp: null | number;
  civilEngDegrad: null | number;
  dco: number;
  qualiMeasure: null | any;
};

export const MeasureInterface = [
  {
    id: 1,
    label: '1',
    automatedTestId: 'mesure-un',
  },
  {
    id: 2,
    label: '2',
    automatedTestId: 'mesure-deux',
  },
  {
    id: 3,
    label: '3',
    automatedTestId: 'mesure-trois',
  },
  {
    id: 4,
    label: '4',
    automatedTestId: 'mesure-quatre',
  },
];

export const DegradationInterface = [
  {
    id: 1,
    label: '1',
    automatedTestId: 'degradation-un',
  },
  {
    id: 2,
    label: '2',
    automatedTestId: 'degradation-deux',
  },
  {
    id: 3,
    label: '3',
    automatedTestId: 'degradation-trois',
  },
  {
    id: 4,
    label: '4',
    automatedTestId: 'degradation-quatre',
  },
];

export const AggravatingInterface = [
  {
    id: 1,
    label: '1',
    automatedTestId: 'facteur-un',
  },
  {
    id: 2,
    label: '2',
    automatedTestId: 'facteur-deux',
  },
];
export const TreatmentTypeInterface = [
  {
    id: 0,
    label: 'Préventif',
    automatedTestId: 'preventive',
  },
  {
    id: 1,
    label: 'Curatif',
    automatedTestId: 'curative',
  },
];
export const TrueFalseInterface = [
  {
    id: 0,
    label: 'Oui',
    automatedTestId: 'true-value',
  },
  {
    id: 1,
    label: 'Non',
    automatedTestId: 'false-value',
  },
];

export type ShowDataCalculProps = {
  form: formType;
  setForm: Function;
  showErrorMessage: { bach: boolean };
};

export type showInspectionProps = {
  form: formType,
  setForm: Function,
  setItvDate: Function,
  itvDate: {
    year: number;
    month: number;
    day: number;
},
  today: {
    year: number;
    month: number;
    day: number;
}};

export type fieldObservationProps = {
  form: formType;
  setForm: Function;
  setLastMeasurementDate: Function;
  setLastVisitDate: Function;
  showErrorMessage: { bach: boolean };
  lastMeasurementDate: {
    year: number;
    month: number;
    day: number;
  };
  today: {
    year: number;
    month: number;
    day: number;
  };
  lastVisitDate: {
    year: number;
    month: number;
    day: number;
  };
};

export const piezoPluvioInterface = [
  {
    id: 1,
    label: 'Pluviomètre',
    automatedTestId: 'mesure-pluvio',
  },
  {
    id: 2,
    label: 'Piézomètre',
    automatedTestId: 'mesure-piezo',
  },
  {
    id: 3,
    label: 'Aucun',
    automatedTestId: 'mesure-aucune',
  },
];

export const pluvioInterface = [
  {
    id: 1,
    label: 'Pluviomètre',
    automatedTestId: 'mesure-pluvio',
  },
  {
    id: 3,
    label: 'Aucun',
    automatedTestId: 'mesure-aucune',
  },
];